/* global window */
import once from '../../../src/js/utils/once.js';
import CookieBannerTriggerButton from './CookieBannerTriggerButton.js';

/**
 * Any link whose href ends with '#cookiebannertrigger'
 * will open the cookie-banner overlay.
 */
export default function() {
    window.Drupal.behaviors.cookieBannerTriggerButton = {
        attach(context) {

            const cookieBannerTriggerButtons = context.querySelectorAll('[href$="#cookiebannertrigger"]');

            for (const button of cookieBannerTriggerButtons) {
                try {
                    once(button, 'cookiebannertriggerbutton', () => {
                        const triggerButton = new CookieBannerTriggerButton(button);
                        triggerButton.setup();
                    });
                } catch (error) {
                    console.error(error);
                }
            }

        },
    };
}
